// Libellés et couleurs des étapes d'une réunion (voir app/services/meeting.py).
export const MEETING_STATUS = {
  recording: { label: 'Enregistrement', tone: 'bg-rose-50 text-rose-700 border-rose-200', busy: true },
  queued: { label: 'En attente du Mac', tone: 'bg-slate-50 text-slate-600 border-slate-200', busy: true },
  transcribing: { label: 'Transcription', tone: 'bg-blue-50 text-blue-700 border-blue-200', busy: true },
  transcribed: { label: 'Transcrite', tone: 'bg-indigo-50 text-indigo-700 border-indigo-200' },
  summarizing: { label: 'Synthèse en cours', tone: 'bg-violet-50 text-violet-700 border-violet-200', busy: true },
  ready: { label: 'Prête', tone: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
  failed: { label: 'Échec', tone: 'bg-amber-50 text-amber-800 border-amber-200' },
  cancelled: { label: 'Annulée', tone: 'bg-slate-50 text-slate-400 border-slate-200' },
};

export const statusOf = (status) => MEETING_STATUS[status] || { label: status, tone: 'bg-slate-50 text-slate-600 border-slate-200' };

export const formatDuration = (seconds) => {
  if (!seconds) return '';
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${Math.max(1, minutes)} min`;
  return `${Math.floor(minutes / 60)} h ${String(minutes % 60).padStart(2, '0')}`;
};

export const formatMeetingDate = (value) => (value
  ? new Date(value).toLocaleString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })
  : '');

// « speaker_0 » → « Intervenant 1 », sauf si un nom a été donné.
export const speakerLabel = (speaker, names = {}) => {
  if (!speaker) return 'Voix non attribuée';
  if (names[speaker]) return names[speaker];
  const match = /^speaker_(\d+)$/.exec(speaker);
  return match ? `Intervenant ${Number(match[1]) + 1}` : speaker;
};
